import React, { Fragment, useEffect, useRef } from "react";
import { Col, FormGroup, Label, Row, Alert } from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AsyncSelect from "react-select/async";
import { mapSearchAutoSuggestion } from "../../../../utils/mapper";
import { getUsersApi } from "../../../../services/manage-user/user";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
    border: "1px solid #dcdcdc",
    "&:hover": {
      borderColor: "#d3d3d3", 
    },
  }),
};

const claimStatus = [
  { id: 0, name: "Won" },
  { id: 1, name: "Loss" },
  { id: 2, name: "Decision Pending" },
];

function ClaimOfferForm(props) {
  const { errors, register, orderState, setValue, getValues, trigger ,watch} = props;

  const refNo = watch("claim_ref_no");
  const claimDate = watch("claim_date");

  useEffect(()=>{

    if(orderState && orderState.claimOfferDialog && orderState.claimOfferDialog.isEdit){
      const status = claimStatus.find(s => s.id === Number(orderState.claimOfferDialog.data.claimStatus));
      const user = orderState.claimOfferDialog.data.claimBy;

      setValue('claim_ref_no', orderState.claimOfferDialog.data.refNo)
      setValue('claim_date', orderState.claimOfferDialog.data.claimDate)
      setValue('claim_status', status)
      setValue('claimed_by', {
        value: user.id,
        label: user.name
      })
    }

  },[orderState])

  const userPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(mapSearchAutoSuggestion(getUsersApi(data)));
      });
    });

  return (
    <Fragment>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label className="form-label">
              Claim Reference Number <span style={{ color: "red" }}>*</span>
            </Label>
            <input
              name="claim_ref_no"
              type="text"
              className={`form-control ${errors.claim_ref_no ? "is-invalid" : ""}`}
              placeholder="2164116410"
              {...register("claim_ref_no")}
            />
            <div className="invalid-feedback">{errors.claim_ref_no?.message}</div>
          </FormGroup>
        </Col>
        <Col md={12}>
          <FormGroup>
            <Label className="form-label">
              Claim Date <span style={{ color: "red" }}>*</span>
            </Label>
            <DatePicker
              name="claim_date"
              className={`form-control digits ${errors.claim_date ? "is-invalid" : ""}`}
              selected={getValues("claim_date") ? new Date(getValues("claim_date")) : null}
              timeFormat="HH:mm"
              dateFormat="dd-MM-yyyy HH:mm"
              showTimeSelect
              timeCaption="Time"
              timeIntervals={10}
              onChange={(date) => {
                setValue("claim_date", date);
                trigger("claim_date");
              }}
            />

            <div className="invalid-feedback">{errors.claim_date?.message}</div>
          </FormGroup>
        </Col>
        { refNo && claimDate &&
          <>
            <Col md={12}>
              <FormGroup>
                <Label className="form-label">
                  Claim Status <span style={{ color: "red" }}>*</span>
                </Label>
                <Select
                  placeholder={<div>Claim Status</div>}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  className="select2-filter"
                  isClearable
                  defaultValue={getValues("claim_status")}
                  styles={customStyles}
                  options={claimStatus}
                  onChange={(e) => {
                    setValue("claim_status", e ? e : null);
                  }}
                />

                <div className="invalid-feedback">{errors.claim_status?.message}</div>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <Label className="form-label">
                  Claim By <span style={{ color: "red" }}>*</span>
                </Label>
                <AsyncSelect
                  className="select2-filter"
                  isClearable={true}
                  cacheOptions
                  defaultOptions
                  defaultValue={getValues('claimed_by')}
                  placeholder="Claimed By"
                  loadOptions={userPromiseOption}
                  styles={{
                    ...customStyles,
                    menuPortal: (base) => ({ ...base, zIndex: 100 }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  onClear={(e) => {}}
                  onChange={(e) => {
                    const user = e ? e : null;
                    setValue("claimed_by", user);
                  }}
                />

                <div className="invalid-feedback">{errors.claimed_by?.message}</div>
              </FormGroup>
            </Col>
          </>
        }
      </Row>
    </Fragment>
  );
}

export default ClaimOfferForm;
